import React, { useState, useEffect, useCallback, useRef } from "react";
import useAppContext from "../../../utils/Reducers";
import ButtonBar from "../../../components/Layout/ButtonBar";
import SearchBar from "./SearchBar";
import { useAxiosWithAuthorization } from "../../../utils/api";
import SelectBox from "../../../components/SelectBox";
import { isFieldDisabled } from "../../../utils/validators";
import { ModalConfirm } from "../../../components/Confirm";
import { gridColumnLayOut } from "./columnLayout";
import { defaultGridProps } from "../../../components/AuiGrid/gridLayout";
import {
  setStorageItem,
  getStorageItem,
} from "../../../hooks/Storage/useLocalStorage";
import moment from "moment";
import AUIGrid from "../../../lib/AuiGrid/AUIGridReact";
import {
  getGridValidateCheck,
  saveGridCheckData,
} from "../../../utils/validators";
import { INITIAL_FIELD_RULES } from "./validateFields";

const SeaTransportMng = (props) => {
  var footerLayout = [
    {
      labelText: "합계",
      positionField: "#base",
    },
    {
      dataField: "wghtDt",
      positionField: "wghtDt",
      operation: "COUNT",
      formatString: "#,##0",
      style: "aui-grid-my-header-sum-total",
    },
    {
      dataField: "carWeight",
      positionField: "carWeight",
      operation: "SUM",
      formatString: "#,##0",
      style: "aui-grid-my-header-sum-total",
    },
    {
      dataField: "realWeight",
      positionField: "realWeight",
      operation: "SUM",
      formatString: "#,##0",
      style: "aui-grid-my-header-sum-total",
    },
    {
      dataField: "outageWght",
      positionField: "outageWght",
      operation: "SUM",
      formatString: "#,##0",
      style: "aui-grid-my-header-sum-total",
    },
  ];

  const myGrid = useRef();

  const gridProps = {
    ...defaultGridProps,
    width: "99%",
    height: 600,

    // 엑스트라 체크박스 표시 설정
    showRowCheckColumn: true,

    // 전체 체크박스 표시 설정
    showRowAllCheckBox: true,

    isRowAllCheckCurrentView: true,
    // 푸터 사용 여부
    showFooter: true,
    footerPosition: "top",
  };

  const {
    store: { userInfo, menuKey },
  } = useAppContext();

  useEffect(() => {
    const auiGrid = myGrid.current;
    auiGrid.resize("100%", 600);
  }, [menuKey]);

  const [searchParameters, setSearchParameters] = useState({
    schPlantCd: userInfo.defaultPlantNo,
    schSearch: "",
    schSwghtDt: moment().format("YYYY-MM-DD"),
    schEwghtDt: moment().format("YYYY-MM-DD"),
  });

  const [state, setState] = useState("updated");

  const [selectWeight, setSelectWeight] = useState(0);

  //추가, 수정일때 항목의 disabled 결정
  const disabledFields = {
    created: [""],
    updated: ["systemCd"],
  };

  const initItem = {
    inspNo: "",
    wghtDt: "",
    plantCd: "",
    wssId: "",
    vhclNo: "",
    vhclType: "",
    vndrCd: "",
    loadAreaCd: "",
    loadAreaNm: "",
    scrapAreaCd: "",
    scrapAreaNm: "",
    magnet: "",
  };

  const inspectionItem = {
    scrapAreaCd: "",
    dcsnItemCd: "",
    outageWght: "",
    outageRsn: "",
    returnCd: "",
    returnRsn: "",
    dprctCd: "",
    dprctRate: "",
    workerId: "",
  };

  const [inspectionValues, setInspectionValues] = useState(inspectionItem);
  //코드 및 그리드 초기화 및 생성
  useEffect(() => {
    const auiGrid = myGrid.current;

    auiGrid.setFooter(footerLayout);

    auiGrid.bind("cellClick", function (event) {
      gridCellClick(event.item);
    });

    auiGrid.bind("rowCheckClick", function (event) {
      gridCellClick(event.item);
      getCheckedRowWeight();
    });

    // 체크된 아이템 얻기
    function getCheckedRowWeight() {
      var total = 0;
      var checkedItems = auiGrid.getCheckedRowItems();
      if (checkedItems.length <= 0) {
        setSelectWeight(total);
        return;
      }
      var str = "";
      var rowItem;

      for (var i = 0, len = checkedItems.length; i < len; i++) {
        rowItem = checkedItems[i].item;
        //console.log(rowItem);
        total = total + parseInt(rowItem.realWeight);

        //console.log(rowItem.realWeight);
      }
      setSelectWeight(total);
    }

    //Local Storage에 저장된 그리드 컬럼 정렬정보를 가져옴
    const columnList = getStorageItem(props.menuInfo.menuId, "");
    if (columnList !== "") {
      auiGrid.setColumnOrder(columnList);
    }
    const columnSize = getStorageItem(props.menuInfo.menuId + "_s", "");
    if (columnSize !== "") {
      //Local Storage에 저장된 그리드 컬럼 Width 정보를 가져옴
      auiGrid.setColumnSizeList(columnSize);
    }

    // 체크박스 클린 이벤트 바인딩
    var allChecked = false;
    auiGrid.bind("rowAllChkClick", function (event) {
      allChecked = !allChecked;
      auiGrid.setAllCheckedRows(allChecked);
      getCheckedRowWeight();
    });
  }, []);

  const [fieldValues, setFieldValues] = useState(initItem);

  const SEARCH_SEATRANSPORTLIST_URL =
    "/domesticscrap/seatransport/searchSeaTransportList.do";
  const SAVE_SEATRANSPORT_URL =
    "/domesticscrap/seatransport/saveSeaTransport.do";

  const [, fetchData] = useAxiosWithAuthorization(
    {
      url: SEARCH_SEATRANSPORTLIST_URL,
    },
    { manual: true }
  );

  const gridCellClick = (item) => {
    const auiGrid = myGrid.current;
    //그리드 셀을 클릭했을 때 데이터 상태
    // 추가 : editable, 수정 : edtiable, 삭제 : readonly
    //read
    //setFieldsEnabled(auiGrid, item, disabledFields);

    /*
    if (item.transStatusCd !== "W") {
      setState("normaled");
      setInspectionValues(item);
    } else if (item.transStatusCd === "W") {
      setState("updated");
    }
    */

    setFieldValues(item);
    auiGrid.addCheckedRowsByIds(item);
    //console.log(item);
    setInspectionValues({
      ...item,
      ["dcsnItemCd"]: item.dcsnItemCd === null ? "" : item.dcsnItemCd,
    });
    setState("updated");
  };

  const handleChangeField = useCallback((event) => {
    const { name, value } = event.target;

    if (
      name === "scrapAreaCd" ||
      name === "outageRsn" ||
      name === "returnRsn" ||
      name === "dprctCd" ||
      name === "returnCd"
    ) {
      var itemNm = event.target.options[event.target.selectedIndex].text;
      setInspectionValues({
        ...inspectionValues,
        [name]: value,
        [name + "Nm"]: itemNm,
      });
      checkedGridUpdateValue(name + "Nm", itemNm);
    } else if (name === "dcsnItemCd") {
      var itemNm = event.target.options[event.target.selectedIndex].text;
      setInspectionValues({
        ...inspectionValues,
        [name]: value,
        ["dcsnItemNm"]: itemNm,
      });
      checkedGridUpdateValue("dcsnItemNm", itemNm);
    } else {
      setInspectionValues({
        ...inspectionValues,
        [name]: value,
      });
    }
    checkedGridUpdateValue(name, value);
  });

  const checkedGridUpdateValue = (name, value) => {
    const auiGrid = myGrid.current;
    var items = auiGrid.getCheckedRowItems();
    for (var i = 0, len = items.length; i < len; i++) {
      var item = items[i];
      auiGrid.setCellValue(item.rowIndex, name, value);
    }
  };
  //그리드 정렬 저장
  const handleGridSorting = useCallback(() => {
    const auiGrid = myGrid.current;
    const items = auiGrid.getColumnInfoList();
    let columnList = [];
    let columnSize = [];
    items.forEach((item) => {
      columnList.push(item.dataField);
      columnSize.push(item.width);
    });
    setStorageItem(props.menuInfo.menuId, columnList);
    setStorageItem(props.menuInfo.menuId + "_s", columnSize);
    ModalConfirm({
      title: "그리드 정렬 저장",
      description: "그리드 정렬을 저장하였습니다. ",
    });
  });

  const handleMasterExcel = useCallback(() => {
    const auiGrid = myGrid.current;
    auiGrid.exportToXlsx({
      fileName: props.menuInfo.menuNmKor + " 리스트",
      exceptColumnFields: auiGrid.getHiddenColumnDataFields(),
    });
  });

  const handleMasterSearch = async () => {
    const auiGrid = myGrid.current;
    auiGrid.showAjaxLoader();
    const {
      data: { data },
    } = await fetchData({
      url: SEARCH_SEATRANSPORTLIST_URL,
      params: searchParameters,
    });
    auiGrid.setGridData(data);
    setFieldValues(initItem);
    setInspectionValues(inspectionItem);
    auiGrid.removeAjaxLoader();
    if (data.length > 0) {
      auiGrid.setSelectionByIndex(0);
      gridCellClick(data[0]);
      setState("updated");
    }
    setSelectWeight(0);
  };

  //그리드 정렬 취소
  const handleGridSortingCancel = useCallback(() => {
    const auiGrid = myGrid.current;
    setStorageItem(props.menuInfo.menuId, "");
    var colLayout = gridColumnLayOut;
    auiGrid.changeColumnLayout(colLayout);
    ModalConfirm({
      title: "그리드 정렬 취소",
      description: "그리드 정렬을 취소하였습니다. ",
    });
  });

  const handleMasterSave = async () => {
    const auiGrid = myGrid.current;
    var items = auiGrid.getCheckedRowItems();
    console.log(items);

    if (items.length > 0) {
      if (
        await ModalConfirm({
          title: "검수등록",
          description: "검수등록하시겠습니까?",
        })
      ) {
        if (
          inspectionValues.scrapAreaCd === "" ||
          inspectionValues.scrapAreaCd === null
        ) {
          ModalConfirm({
            title: "필수항목체크 ",
            description: "하차지를 선택하지 않았습니다. ",
            type: "alert",
          });
          return;
        }

        if (
          inspectionValues.dcsnItemCd === "" ||
          inspectionValues.dcsnItemCd === null
        ) {
          ModalConfirm({
            title: "필수항목체크",
            description: "검수등급을 선택하지 않았습니다. ",
            type: "alert",
          });
          document.getElementsByName("dcsnItemCd")[0].focus();
          return;
        }

        if (
          inspectionValues.outageWght === "" ||
          inspectionValues.outageWght === null ||
          inspectionValues.outageWght === undefined
        ) {
        } else {
          if (
            inspectionValues.outageRsn === "" ||
            inspectionValues.outageRsn === null ||
            inspectionValues.outageRsn === undefined
          ) {
            alert("감량사유를 선택하지 않았습니다. ");
            return;
          }
        }

        if (
          inspectionValues.returnCd === "" ||
          inspectionValues.returnCd === null ||
          inspectionValues.returnCd === undefined
        ) {
        } else {
          if (
            inspectionValues.returnRsn === "" ||
            inspectionValues.returnRsn === null ||
            inspectionValues.returnRsn === undefined
          ) {
            alert("반품사유를 선택하지 않았습니다. ");
            return;
          }
        }
        if (inspectionValues.systemCd === "DH") {
          if (
            inspectionValues.dprctRate === "" ||
            inspectionValues.dprctRate === null ||
            inspectionValues.dprctRate === undefined
          ) {
          } else {
            if (
              inspectionValues.dprctCd === "" ||
              inspectionValues.dprctCd === null ||
              inspectionValues.dprctCd === undefined
            ) {
              alert("감가내역를 선택하지 않았습니다. ");
              return;
            }
          }
        }

        let param = [];
        if (items && items.length > 0) {
          for (var i = 0, len = items.length; i < len; i++) {
            if (items[i].item.inspNo === "" || items[i].item.inspNo === null) {
              items[i].item.status = "C";
              items[i].item.inspNo = items[i].item.wssId;
            } else {
              items[i].item.status = "U";
            }

            if (items[i].scrapAreaCd === "" || items[i].scrapAreaCd === null) {
              ModalConfirm({
                title: "필수항목체크 ",
                description: "하차지를 선택하지 않았습니다. ",
                type: "alert",
              });
              return;
            }

            if (items[i].dcsnItemCd === "" || items[i].dcsnItemCd === null) {
              ModalConfirm({
                title: "필수항목체크",
                description: "검수등급을 선택하지 않았습니다. ",
                type: "alert",
              });
              document.getElementsByName("dcsnItemCd")[0].focus();
              return;
            }

            if (
              items[i].outageWght === "" ||
              items[i].outageWght === null ||
              items[i].outageWght === undefined
            ) {
            } else {
              if (
                items[i].outageRsn === "" ||
                items[i].outageRsn === null ||
                items[i].outageRsn === undefined
              ) {
                alert("감량사유를 선택하지 않았습니다. ");
                return;
              }
            }

            if (
              items[i].returnCd === "" ||
              items[i].returnCd === null ||
              items[i].returnCd === undefined
            ) {
            } else {
              if (
                items[i].returnRsn === "" ||
                items[i].returnRsn === null ||
                items[i].returnRsn === undefined
              ) {
                alert("반품사유를 선택하지 않았습니다. ");
                return;
              }
            }
            if (items[i].systemCd === "DH") {
              if (
                items[i].dprctRate === "" ||
                items[i].dprctRate === null ||
                items[i].dprctRate === undefined
              ) {
              } else {
                if (
                  items[i].dprctCd === "" ||
                  items[i].dprctCd === null ||
                  items[i].dprctCd === undefined
                ) {
                  alert("감가내역를 선택하지 않았습니다. ");
                  return;
                }
              }
            }

            //console.log(items);
            param.push(items[i].item);
          }

          const {
            data: { data },
          } = await fetchData({
            url: SAVE_SEATRANSPORT_URL,
            data: param,
            method: "POST",
          });
          handleMasterSearch();
        }
      }
    } else {
      ModalConfirm({
        title: "검수항목체크",
        description: "체크한 항목이 없습니다. ",
        type: "alert",
      });
    }
  };

  const handleMasterInit = () => {
    setInspectionValues(inspectionItem);
  };

  return (
    <>
      <ButtonBar
        menuInfo={props.menuInfo}
        isInitButton={true}
        handleMasterInit={handleMasterInit}
        handleMasterSearch={handleMasterSearch}
        handleMasterSave={handleMasterSave}
        handleMasterExcel={handleMasterExcel}
        isGridSort={true}
        handleGridSorting={handleGridSorting}
        handleGridSortingCancel={handleGridSortingCancel}
      />
      <SearchBar
        setSearchParameters={setSearchParameters}
        searchParameters={searchParameters}
      />
      <table className="t_garo">
        <tr>
          <td>
            {" "}
            선택 입고중량 :{" "}
            {selectWeight.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} kg
          </td>
        </tr>
      </table>
      <div className="flexible_contents_box3">
        <div className="databox cctv_half">
          <div className="tabbox" id="mTabContents">
            <div style={{ width: "100%", height: "100%" }}>
              <AUIGrid
                ref={myGrid}
                columnLayout={gridColumnLayOut}
                gridProps={gridProps}
                width="100%"
                height={450}
              />
            </div>
          </div>
        </div>
        <div className="databox">
          <div className="subdatabox">
            <div id="mTableTab">
              <div className="table_list on">
                <ul className="t_form">
                  <li className="half">
                    <div className="title">사전등급</div>
                    <div className="formbox">
                      <SelectBox
                        mastCd="ITEM_CD"
                        id="itemCd"
                        name="itemCd"
                        disabled={true}
                        topSelected="선택"
                        value={fieldValues.itemCd}
                        className="ip2"
                      />
                    </div>
                  </li>
                  <li className="">
                    <div className="title">차량번호</div>
                    <div className="formbox">
                      <div>
                        <input
                          type="text"
                          id="vhclNo"
                          name="vhclNo"
                          disabled={true}
                          value={fieldValues.vhclNo}
                          className="ip2"
                        />
                      </div>
                    </div>
                  </li>
                  <li className="">
                    <div className="title">상차업체</div>
                    <div className="formbox">
                      <input
                        type="text"
                        id="loadAreaNm"
                        name="loadAreaNm"
                        disabled={true}
                        value={fieldValues.loadAreaNm}
                        className="ip2"
                      />
                    </div>
                  </li>
                  <li className="">
                    <div className="title">하차지</div>
                    <div className="formbox">
                      <div>
                        <SelectBox
                          mastCd="SCRAP_AREA_CD"
                          id="scrapAreaCd"
                          name="scrapAreaCd"
                          topSelected="선택"
                          disabled={isFieldDisabled(
                            state,
                            "scrapAreaCd",
                            disabledFields
                          )}
                          onChange={handleChangeField}
                          value={inspectionValues.scrapAreaCd}
                          className="ip2"
                        />
                      </div>
                    </div>
                  </li>
                  <li className="half">
                    <div className="title">입차일시</div>
                    <div className="formbox">
                      <input
                        type="text"
                        id="inptDt"
                        name="inptDt"
                        topSelected="선택"
                        disabled="true"
                        value={fieldValues.inptDt}
                        className="ip2"
                      />
                    </div>
                  </li>
                  <li className="half">
                    <div className="title">총중량</div>
                    <div className="formbox">
                      <input
                        type="text"
                        id="totalWeight"
                        name="totalWeight"
                        disabled="true"
                        value={fieldValues.totalWeight}
                        className="ip2"
                      />
                    </div>
                  </li>
                  <li className="">
                    <div className="title">검수등급</div>
                    <div className="formbox">
                      <SelectBox
                        mastCd="ITEM_CD"
                        id="dcsnItemCd"
                        name="dcsnItemCd"
                        topSelected="선택"
                        disabled={isFieldDisabled(
                          state,
                          "dcsnItemCd",
                          disabledFields
                        )}
                        onChange={handleChangeField}
                        value={inspectionValues.dcsnItemCd}
                        className="ip2"
                      />
                    </div>
                  </li>
                </ul>

                <ul className="t_form">
                  <li className="half">
                    <div className="title">감량</div>
                    <div className="formbox">
                      <SelectBox
                        mastCd="OUTAGE_WGHT"
                        id="outageWght"
                        name="outageWght"
                        topSelected="선택"
                        disabled={isFieldDisabled(
                          state,
                          "outageWght",
                          disabledFields
                        )}
                        onChange={handleChangeField}
                        value={inspectionValues.outageWght}
                        className="ip2"
                      />
                    </div>
                  </li>
                  <li className="half">
                    <div className="title">사유</div>
                    <div className="formbox">
                      <SelectBox
                        mastCd="OUTAGE_CD"
                        id="outageRsn"
                        name="outageRsn"
                        topSelected="선택"
                        disabled={isFieldDisabled(
                          state,
                          "outageRsn",
                          disabledFields
                        )}
                        onChange={handleChangeField}
                        value={inspectionValues.outageRsn}
                        className="ip2"
                      />
                    </div>
                  </li>
                  <li className="half">
                    <div className="title">반품/경고</div>
                    <div className="formbox">
                      <SelectBox
                        mastCd="RETURN_CD"
                        id="returnCd"
                        name="returnCd"
                        topSelected="선택"
                        disabled={isFieldDisabled(
                          state,
                          "returnCd",
                          disabledFields
                        )}
                        onChange={handleChangeField}
                        value={inspectionValues.returnCd}
                        className="ip2"
                      />
                    </div>
                  </li>
                  <li className="half">
                    <div className="title">사유</div>
                    <div className="formbox">
                      <SelectBox
                        mastCd="OUTAGE_CD"
                        id="returnRsn"
                        name="returnRsn"
                        topSelected="선택"
                        disabled={isFieldDisabled(
                          state,
                          "returnRsn",
                          disabledFields
                        )}
                        onChange={handleChangeField}
                        value={inspectionValues.returnRsn}
                        className="ip2"
                      />
                    </div>
                  </li>
                  <li className="half">
                    <div className="title">감가비율</div>
                    <div className="formbox">
                      <SelectBox
                        mastCd="ITEM_RATE"
                        id="dprctRate"
                        name="dprctRate"
                        disabled={isFieldDisabled(
                          state,
                          "dprctRate",
                          disabledFields
                        )}
                        topSelected="선택"
                        onChange={handleChangeField}
                        value={inspectionValues.dprctRate}
                        className="ip2"
                      />
                    </div>
                  </li>
                  <li className="half">
                    <div className="title">감가내역</div>
                    <div className="formbox">
                      <SelectBox
                        mastCd="DPRCT_CD"
                        id="dprctCd"
                        name="dprctCd"
                        topSelected="선택"
                        disabled={isFieldDisabled(
                          state,
                          "dprctCd",
                          disabledFields
                        )}
                        onChange={handleChangeField}
                        value={inspectionValues.dprctCd}
                        className="ip2"
                      />
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SeaTransportMng;
